import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Parcel } from 'src/interfaces/waybill';

@Component({
    selector: 'core-add-parcel',
    templateUrl: './add-parcel.component.html',
    styleUrls: ['./add-parcel.component.scss'],
    standalone: false
})
export class AddParcelComponent implements OnInit {

  @Output() onAddParcel = new EventEmitter<Parcel>();
  @Input() waybillNo: string;
  parcelForm = this._formBuilder.group({
    length: ['', Validators.required],
    height: ['', Validators.required],
    width: ['', Validators.required],
    mass: ['', Validators.required],
    parcelDescription: ['', Validators.maxLength(50)],
    parcelNo: ['', Validators.maxLength(15)],
    parcelCount: ['', Validators.required],
  })

  constructor(
    private _formBuilder: UntypedFormBuilder
  ) { }

  ngOnInit(): void {
  }


  addParcel(): void {

    const parcel: Parcel = {
      waybillNo: this.waybillNo,
      length: this.parcelForm.value.length,
      height: this.parcelForm.value.height,
      width: this.parcelForm.value.width,
      mass: this.parcelForm.value.mass,
      parcelDescription: this.parcelForm
        .value
        .parcelDescription ?
        this.parcelForm
          .value
          .parcelDescription : undefined,
      parcelNo: this.parcelForm
        .value
        .parcelNo ? this.parcelForm
          .value
        .parcelNo : undefined,
      parcelCount: this.parcelForm
        .value
        .parcelCount
    };

    this.onAddParcel.emit(parcel);

    // reset the parcel form 
    this.parcelForm.reset();
  }

}
